import React, { useEffect } from "react";
import * as Icons from 'lucide-react';


export const ThankYou = () => {
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-401331995/LQrkCKnZm6IYEJuur78B",
      });
    }
  }, []);


  return (
    <div className="bg-black text-white min-h-screen flex items-center justify-center">
        <Icons.ThumbsUp className="w-16 h-16 text-gold-primary mb-4" />
      <h1 className="text-4xl font-bold">Thank You for Contacting Us!</h1>
    </div>
  );
}